// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3JU7xfKBkPAyL9GVE7daKv"};